import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import React from 'react';
import { Text } from '@descope/page-editor-components';
import { ITheme } from 'types/theme';
import styled from '@emotion/styled';
import { TypographyVariants, VariantsList } from './types';
import { componentVariantNames, typographyVariantNames } from './constants';

type Props = {
	selected: TypographyVariants;
	setSelected: (size: TypographyVariants) => void;
	variants: VariantsList;
};

// button & input do not have typography classes,
// instead, the css var is defined in their component style,
// therefor we need to set the var manually here so the list item will get the correct style
const StyledBox = styled(Box)`
	.descope-typography-button {
		font-family: var(--button-fontFamily);
	}

	.descope-typography-input {
		font-family: var(--input-fontFamily);
	}
`;

export default ({ setSelected, selected, variants }: Props) => {
	const theme = useTheme<ITheme>();

	return (
		<StyledBox overflow="hidden">
			<List>
				{variants.map((variant) => (
					<ListItem disablePadding key={variant}>
						<ListItemButton
							selected={variant === selected}
							onClick={() => setSelected(variant)}
							sx={{
								borderRight: variant === selected ? 2 : 0,
								borderColor: 'primary.main'
							}}
						>
							<Text
								className={
									typographyVariantNames.includes(variant)
										? `descope-typography-${variant}`
										: undefined
								}
								style={{
									fontFamily: componentVariantNames.includes(variant)
										? `var(--${variant}-font-family)`
										: undefined,
									color:
										variant === selected
											? theme.palette.primary.main
											: 'currentcolor',
									textTransform: 'capitalize'
								}}
							>
								{variant}
							</Text>
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</StyledBox>
	);
};
